/**
 * Mobile browsers only let a page play sound after a user gesture. The voice
 * screen starts listening and answers later, so one <audio> element is "unlocked"
 * inside the tap that opens it and reused for every reply.
 */

// 0.1 s of silence.
const SILENT_WAV =
  'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';

let shared: HTMLAudioElement | null = null;

export function getSharedAudio(): HTMLAudioElement {
  shared ??= new Audio();
  return shared;
}

/** Call synchronously from a click/tap handler. Never throws. */
export function unlockAudio(): void {
  try {
    const audio = getSharedAudio();
    audio.src = SILENT_WAV;
    void audio.play().catch(() => undefined);
  } catch {
    /* audio is optional: the browser voice is the fallback */
  }
}
